<template>
  <div class="container remove-padding-margin">
    <div class="container remove-padding-margin" id="detailoutlet">
      <div id="loadingPageImport">
        <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
        <center>
          <h4 style="margin-top:15px"><span class="count" id="dataCOunter">0</span>%</h4>
          <h5>Proses Duplikasi Data..</h5>
        </center>
      </div>
      <div class="header-top bg-white">
        <div class="row justify-content-center align-items-center set-row w-limit">
          <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
            <img src="../../assets/gambar/back-blue.svg" alt="">
          </div>
          <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
            <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Detail Outlet</h6>
          </div>
          <div class="col-md-2 col-sm-2 col-2">
          </div>
        </div>
      </div>
      <!--        <div class="pembatas">-->

      <!--        </div>-->
      <main class="w-limit">
        <div class="text-alignC pad-top-50">
          <div class="p-l-20 p-r-20 p-d-12 p-t-12 nonActiveOutlet m-d-20 text-left"
               v-if="outlet.sec_active !== 2">
            <p class="f-14 m-d-4" v-if="outlet.sec_active === 1 && !outlet.additionalInfo.expired">
              Masa trial tersisa <b>{{ outlet.additionalInfo.remaining_trial_days }} hari</b>. Segera aktivasi outlet ini agar tetap bisa melakukan transaksi.
            </p>
            <p class="f-14 m-d-4" v-if="outlet.sec_active === 0 || outlet.additionalInfo.expired">
              Masa trial sudah habis. Segera aktivasi outlet ini agar tetap bisa melakukan transaksi.
            </p>
            <p class="f-14 m-0 f-c-red" @click="aktivasiOutlet">
              <b>Klik disini untuk aktivasi 🡪</b>
            </p>
          </div>
          <!--                <img class="mar-top-20 mar-bottom-20" v-bind:src="outlet.logo_url" v-if="outlet.logo_url" alt="">-->
          <div v-if="outlet.logo_url == '' || outlet.logo_url == null"
               class="upload-file-wrapper mar-top-20 mar-bottom-20">
            <label for="file">
              <img src="../../assets/gambar/Rectangle43.svg" alt=""
                   style="width: 100px;height: 100px;border-radius: 3px;"
                   id="logo">
              <div class="pointer-upload">
                <img src="../../assets/icons/camera1.svg" alt="">
              </div>
            </label>
            <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUpload"
                   accept=".png, .jpg, .jpeg"/>
          </div>
          <div v-else class="upload-file-wrapper mar-top-20 mar-bottom-20">
            <label for="file">
              <figure class="box">
                <img class="imgFit"
                     v-bind:src="imgBucketSrc + outlet.logo_url"
                     alt=""
                     v-if="outlet.logo_url.includes('bos_revamp/')"
                     id="logo">
                <img class="imgFit"
                     v-bind:src="'https://res.cloudinary.com/sinadme/c_scale,h_200/'+ outlet.logo_url"
                     alt=""
                     v-else
                     id="logo">
              </figure>
              <div class="pointer-upload">
                <img src="../../assets/icons/camera1.svg" alt="">
              </div>
            </label>
            <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUpload"
                   accept=".png, .jpg, .jpeg"/>
          </div>
        </div>
        <!--            <div class="mar-top-16">-->
        <!--                <div class="font-18 font-weight-600 color-0000 letter-space-002 line-height-25 text-center">{{outlet.nama}}</div>-->
        <!--                <div class="line-height-21 letter-space-002 color-6f7 font-14 text-center">{{outlet.alamat}},{{outlet.kota}}</div>-->
        <!--                <div class="line-height-21 letter-space-002 color-6f7 font-14 text-center">+{{outlet.telp}}</div>-->
        <!--                <div class="text-alignC d-flex justify-content-center mar-top-16 mar-bottom-30">-->
        <!--                    <button type="button" class="btn btn-outline-primary  d-flex justify-content-center" style="width: 81px"><span style="margin-right: 6px"><img src="../../assets/icons/ic_baseline-edit.svg" alt=""></span>Ubah</button>-->
        <!--                </div>-->
        <!--            </div>-->
        <div>
          <div class="row remove-margin text-detailO" :data-toggle="validateAccess('outlet.update') && 'modal'" data-target="#modalEname">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14  mar-top-5 mar-bot-0 color-8080">
                Nama Outlet
              </h6>
              <h6 class="nomore">
                {{ outlet.nama }}
              </h6>
            </div>
            <div v-if="validateAccess('outlet.update')  " class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><i class="far fa-edit color-206CF"></i></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO" :data-toggle="validateAccess('outlet.update') ? 'modal' : ''" data-target="#modalEtelp">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 mar-top-5 mar-bot-0 color-8080">
                Nomor Telephone
              </h6>
              <h6>
                {{ outlet.telp }}
              </h6>
            </div>
            <div v-if="validateAccess('outlet.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><i class="far fa-edit color-206CF"></i></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO" :data-toggle="validateAccess('outlet.update') && 'modal'" data-target="#modalEkota">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 mar-top-5 mar-bot-0 color-8080">
                Kota
              </h6>
              <h6>
                {{ outlet.kota }}
              </h6>
            </div>
            <div v-if="validateAccess('outlet.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><i class="far fa-edit color-206CF"></i></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO" :data-toggle="validateAccess('outlet.update') && 'modal'" data-target="#modalEaddress">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin ">
              <h6 class="font-14 mar-top-5 mar-bot-0 color-8080">
                Alamat Outlet
              </h6>
              <h6 class="nomore">
                {{ outlet.alamat }}
              </h6>
            </div>
            <div v-if="validateAccess('outlet.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><i class="far fa-edit color-206CF"></i></span>
            </div>
          </div>
        </div>
        <div class="pembatas remove-margin"></div>
        <div>
          <div class="row remove-margin text-detailO d-flex align-items-center btn-list-services"
               @click="golayanan" v-if="validateAccess('regularServices.read')">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Layanan Reguler
              </h6>
              <span class="f-14 f-c-midgrey" v-if="countComponentOutlet.layanan > 0">
		                        {{ countComponentOutlet.layanan }} Layanan Terdaftar
	                        </span>
              <span class="f-14 f-c-midgrey" v-else>
		                        Belum ada
	                        </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 text-right remove-padding">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div v-if="isWebview() && getBetaFeature(inventoryKey, true)" class="row remove-margin text-detailO d-flex align-items-center" @click="goProductSale">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Produk Dijual
              </h6>
              <span class="f-14 f-c-midgrey">
                {{ countComponentOutlet.produk > 0 ? countComponentOutlet.produk + ' Produk Dijual' : 'Belum ada' }}
              </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('selfServices.read')" @click="golayanansnap">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Layanan Self-Service
              </h6>
              <span class="f-14 f-c-midgrey" v-if="countComponentOutlet.snapclean > 0">
		                        {{ countComponentOutlet.snapclean }} Layanan Terdaftar
	                        </span>
              <span class="f-14 f-c-midgrey" v-else>
		                        Belum ada
	                        </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center"
               @click="golistmesin(outlet.idoutlet)" v-if="validateAccess('snapBridge.read')">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Mesin Snapbridge
              </h6>
              <span v-if="countComponentOutlet.snapmesin > 0" class="f-14 f-c-midgrey">{{ countComponentOutlet.snapmesin }} Mesin Terdaftar</span>
              <span v-else class="f-14 f-c-midgrey">Belum ada</span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center"
               @click="golistkategoriMesin(outlet.idoutlet)" v-if="false">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Kategori Mesin Snapbridge
              </h6>
              <span class="f-14 f-c-midgrey">Lihat detail</span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('epayment.read')" @click="gopayment">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10  remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Paket E-Payment
              </h6>
              <span class="f-14 f-c-midgrey" v-if="countComponentOutlet.epayment > 0">
		                        {{ countComponentOutlet.epayment }} Paket e-payment terdaftar
	                        </span>
              <span class="f-14 f-c-midgrey" v-else>
		                        Belum ada
	                        </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>

          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('depositPackage.read')" @click="godeposit">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10  remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Paket Deposit
              </h6>
              <span class="f-14 f-c-midgrey" v-if="countComponentOutlet.deposit > 0">
		                        {{ countComponentOutlet.deposit }} Paket deposit terdaftar
	                        </span>
              <span class="f-14 f-c-midgrey" v-else>
		                        Belum ada
	                        </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('perfume.read')" @click="goperfume">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Jenis Parfum
              </h6>
              <span class="f-14 f-c-midgrey" v-if="countComponentOutlet.parfum > 0">
		                        {{ countComponentOutlet.parfum }} Jenis Parfum terdaftar
	                        </span>
              <span class="f-14 f-c-midgrey" v-else>
		                        Belum ada
	                        </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('rack.read')" @click="gorak">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <div class="font-14 font-weight-bold">Daftar Rak</div>
              <span class="f-14 f-c-midgrey" v-if="countComponentOutlet.rak > 0">
		                        {{ countComponentOutlet.rak }} Rak terdaftar
	                        </span>
              <span class="f-14 f-c-midgrey" v-else>
		                        Belum ada
	                        </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('outlet.outletProductionProces')" @click="gosetproduksi">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Pengaturan Proses Produksi
              </h6>
              <div v-if="outlet.workshop_idworkshop===null" class="font-14 remove-margin color-80808">
                Tidak ada proses produksi
              </div>
              <div v-else class="font-14 remove-margin color-80808">
                Ada proses produksi
              </div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 text-right remove-padding">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('transactionSetting.read')" @click="gosettax">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Pengaturan Transaksi
              </h6>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('noteSetting.read')" @click="gosetnota">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Pengaturan Nota
              </h6>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('absentSettings.read')" @click="gosetlokasioutlet">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Pengaturan Absen Karyawan
              </h6>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>
          <!--    <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('smartConsole.read')" @click="golistconsole(outlet.idoutlet)">
                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                  <h6 class="font-14 remove-margin font-colorcheck text-promo">
                    Daftar Smart Console
                  </h6>
                  <span class="f-14 f-c-midgrey">
                    Lihat detail
                  </span>
                </div>
                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
                  <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
                </div>
              </div>-->
          <div class="row remove-margin text-detailO d-flex align-items-center" v-if="validateAccess('item.read')" @click="goitemdetails(outlet.idoutlet)">
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo">
                Daftar Item
              </h6>
              <span class="f-14 f-c-midgrey">
                Lihat detail
              </span>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
              <span><img src="../../assets/icons/chevron-right1.svg" alt=""></span>
            </div>
          </div>


          <div class="pembatas-new"></div>
          <div class="row remove-margin text-detailO" data-toggle="modal" data-target="#modalDuplikat" v-if="validateAccess('outlet.update')">
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin">
              <span><img class="mar-top-5" src="../../assets/icons/copy.svg" alt=""></span>
            </div>
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
              <h6 class="font-14 remove-margin font-colorcheck text-promo" style="margin-top: 10px">
                Duplikat Outlet
              </h6>
            </div>
          </div>
          <div class="row remove-margin text-detailO" data-toggle="modal" data-target="#modalHide" v-if="validateAccess('outlet.hide')">
            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin">
              <span><img class="mar-top-5" src="../../assets/icons/eye-off.svg" alt=""></span>
            </div>
            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin ">
              <h6 class="font-14 remove-margin font-colorcheck text-promo" style="margin-top: 10px">
                Sembunyikan Outlet
              </h6>
            </div>
          </div>
        </div>
      </main>
      <div class="modal fade" id="modalEname" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content w-limit">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Ubah Nama Outlet</h5>
              <div class="nav-btn kanan tutup">
                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
              </div>
            </div>
            <div class="modal-body">
              <form action="">
                <div class="form-group">
                  <label class="remove-margin font-14 color-8080 require" for="namaDoutlet">Nama
                    Outlet </label>
                  <input type="text" class="form-control inputs" id="namaDoutlet"
                         v-model="editnama" @keyup="inputnamaoutlet">
                  <ErrorMessage class="error" label="Nama" :validation="$v.editnama"></ErrorMessage>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary btn-long"
                      @click="updateName" id="Btneditname">Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalEtelp" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content w-limit">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Ubah Nomor Telpon Outlet</h5>
              <div class="nav-btn kanan tutup">
                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
              </div>
            </div>
            <div class="modal-body">
              <form action="">
                <div class="form-group">
                  <label class="remove-margin font-14 color-8080 require" for="telpoutlet">Telpon
                    Outlet</label>
                  <div class="input-group remove-padding mod">
                    <vue-country-code
                        @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                    </vue-country-code>
                    <input type="tel" class="form-control inputs" id="telpoutlet"
                           v-model="edittelp" v-on:keyup="nomorWaOnkeyup"
                           @paste="nomorWaOnkeyup"
                    >
                  </div>
                </div>
                <ErrorMessage class="error" label="Nomor Telepon" :validation="$v.edittelp"></ErrorMessage>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary btn-long" id="buttontelp"
                      @click="updateTelp">Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalEkota" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content w-limit">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Ubah Kota Outlet</h5>
              <div class="nav-btn kanan tutup">
                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
              </div>
            </div>
            <div class="modal-body set-modal-body">
              <div class="mod">
                <label class="p-x-20 remove-margin font-14 color-8080 require">Kota Outlet</label>
                <Select2 class="p-x-20" id="select2"
                         v-model="editkota" :options="optionskota"
                         :settings="{ placeholder: 'Pilih Kota' }"
                         @change="myChangeEvent($event)" @select="mySelectEvent($event)"/>
              </div>
            </div>
            <ErrorMessage class="error" label="Kota" :validation="$v.editkota"></ErrorMessage>

            <div class="modal-footer">
              <div class="button-wrapper w-limit w-100">
                <div class="btn smart-secondary btn-long" @click="updateKota"
                >Simpan
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalEaddress" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content w-limit">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Ubah Alamat Outlet</h5>
              <div class="nav-btn kanan tutup">
                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
              </div>
            </div>
            <div class="modal-body">
              <form action="">
                <div class="form-group">
                  <label class="remove-margin font-14 color-8080 require" for="addressdetail">Alamat
                    Outlet</label>
                  <input type="text" class="form-control inputs" id="addressdetail"
                         v-model="editalamat" @keyup="inputalamat">
                  <ErrorMessage class="error" label="Alamat" :validation="$v.editalamat"></ErrorMessage>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary btn-long"
                      @click="updateAddress">Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalDuplikat" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content w-limit">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Duplikat Outlet</h5>
              <div class="nav-btn kanan tutup">
                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
              </div>
            </div>
            <div class="modal-body">
              <form action="">
                <div class="form-group remove-margin">
                  <div class="remove-margin text-desc">Dengan duplikat outlet data dan pengaturan
                    outlet akan
                    tersalin secara otomatis
                  </div>
                  <label class="mar-top-12 mar-b font-16 require" for="copyutlet"
                         style="margin-bottom: 4px; color: rgba(0, 0, 0, 0.65) ;">Nama outlet
                    hasil
                    duplikat</label>
                  <input type="text" class="form-control inputs mar-bottom-20 font-16"
                         v-model="duplikat_nama"
                         id="copyutlet" v-on:keyup="inputnama">
                  <h6 class="" style="margin-bottom: 8px">Pengaturan outlet yang akan
                    di-duplikat:</h6>

                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" class="custom-control-input" id="customCheck1"
                           @change="cekALlList">
                    <label class="custom-control-label" for="customCheck1" id="textCheckAll">Pilih
                      Semua</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="layanan"
                           value="layanan">
                    <label class="custom-control-label" for="layanan">Daftar Layanan</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="paket_deposit"
                           value="paket_deposit">
                    <label class="custom-control-label" for="paket_deposit">Daftar Paket
                      Deposit</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="paket_epayment"
                           value="paket_epayment">
                    <label class="custom-control-label" for="paket_epayment">Daftar Paket
                      E-payment</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="jenis_parfum"
                           value="jenis_parfum">
                    <label class="custom-control-label" for="jenis_parfum">Daftar Jenis
                      Parfum</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="pengaturan_rak"
                           value="pengaturan_rak">
                    <label class="custom-control-label" for="pengaturan_rak">Pengaturan
                      Rak</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="pengaturan_pajak_promo"
                           value="pengaturan_pajak_promo">
                    <label class="custom-control-label" for="pengaturan_pajak_promo">Pengaturan
                      Pajak & Promo</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="pengaturan_nota"
                           value="pengaturan_nota">
                    <label class="custom-control-label" for="pengaturan_nota">Pengaturan
                      Nota</label>
                  </div>
                  <div class="custom-control custom-checkbox remove-padding">
                    <input type="checkbox" v-model="ceklistproses" @change="cekItemList"
                           class="custom-control-input classCekAll" id="data_workshop"
                           value="data_workshop">
                    <label class="custom-control-label" for="data_workshop">Data
                      Workshop</label>
                    <div class="font-12 letter-space-002 line-height-18 color-6f7">Aktifkan jika
                      anda ingin menduplikat data workshop yangterhubung dengan outlet ini
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <div class="">
              </div>
              <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                      @click="DuplikatOutlet" id="buttonduplikat" disabled>Buat Duplikat
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalHide" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Sembunyikan Outlet</h5>
              <div class="nav-btn kanan tutup">
                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
              </div>
            </div>
            <div class="modal-body">
              <div class="remove-margin font-16 letter-space-002 line-height-21 color-33333">Semua
                data keuangan akan tetap tersimpan & ditampilkan. Yakin ingin <b>menyembunyikan</b>
                outlet <b>{{ outlet.nama }}</b>?
              </div>
              <div class="font-16 letter-space-002 line-height-21 color-33333 mar-top-20">Anda tetap
                bisa menampilkannya pada halaman daftar outlet.
              </div>
            </div>
            <div class="modal-footer remove-margin">
              <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                      @click="deloutlet">Ya, sembunyikan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SetProduction v-bind:class="{hidesection: !issetProduksi}" v-on:isdetail="isdetail"
                   v-bind:setidoutlet="idoutlet" ref="setproduksi"/>
    <TaxSetting
		v-bind:class="{hidesection: !istaxsetting}"
		v-on:isdetail="isdetail"
		v-bind:setidoutlet="idoutlet"
		ref="settax"
		v-if="validateAccess('transactionSetting.read')"
	/>
    <SetNota v-bind:class="{hidesection: !issetnota}" v-on:isdetail="isdetail" v-bind:setidoutlet="idoutlet"
             ref="setnota"/>
    <PengaturanLayanan v-bind:class="{hidesection: !issetservice}" v-on:isdetail="isdetail"
                       v-bind:setidoutlet="idoutlet" ref="setservice"/>
    <SetSnapService v-bind:class="{hidesection: !issetsnapservice}" v-on:isdetail="isdetail"
                    v-bind:setidoutlet="idoutlet" ref="setservicesnap"/>
    <DataPerfume v-bind:class="{hidesection: !isdataperfume}" v-on:isdetail="isdetail" v-bind:setidoutlet="idoutlet"
                 ref="dataperfume"/>
    <SetDeposit v-bind:class="{hidesection: !isdatadeposit}" v-on:isdetail="isdetail" v-bind:setidoutlet="idoutlet"
                ref="datadeposit" @toLayanan="golayanan"/>
    <SetEpayment v-bind:class="{hidesection: !isdataepayment}" v-on:isdetail="isdetail"
                 v-bind:setidoutlet="idoutlet" ref="dataepayment"/>
    <SetRak v-bind:class="{hidesection: !isdatarak}" v-on:isdetail="isdetail" v-bind:setidoutlet="idoutlet"
            ref="datarak"/>
    <MesinIbos v-bind:class="{hidesection: !isdatamesinibos}" v-on:isdetail="isdetail" v-bind:setidoutlet="idoutlet"
               ref="datamesinibos"/>
    <RadiusOutlet v-bind:class="{hidesection: !isdatalokasioutlet}" v-on:isdetail="isdetail" v-bind:idoutlet="idoutlet"
                  ref="radiusoutletref"/>

  </div>
</template>

<script>
import Select2 from 'v-select2-component';
import SetProduction from "../production/SetProduction";
import TaxSetting from "./TaxSetting";
import SetNota from "../Outlet/Nota/SetNota";
import PengaturanLayanan from "../Outlet/Layanan/PengaturanLayanan";
import SetSnapService from "../Outlet/Layanan Snap/SetSnapService";
import DataPerfume from "./DataPerfume";
import SetDeposit from "../Outlet/Deposit/SetDeposit";
import SetEpayment from "../Outlet/E-Payment/SetEpayment";
import SetRak from "../Outlet/Rak/SetRak";
import MesinIbos from "../Outlet/MesinIbos/MesinIbos";
import RadiusOutlet from "./LokasiOutlet/RadiusOutlet";
import ErrorMessage from "@/component-items/ErrorMessage";
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import {betaKeys} from '@/store/utils/vars';

export default {
  name: "DetailOutlet",
  props: ["datalistoutlet"],
  components: {
    SetRak,
    SetEpayment,
    SetDeposit,
    DataPerfume,
    SetSnapService,
    PengaturanLayanan,
    SetNota,
    Select2,
    SetProduction,
    TaxSetting,
    MesinIbos,
    RadiusOutlet,
    ErrorMessage
  },
  validations: {
    editnama: {
      required,
      minLength: minLength(2),
    },
    edittelp: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(12),
    },
    editkota: {
      required,
    },
    editalamat: {
      required,
      minLength: minLength(2),
    }
  },
  mounted() {
    this.idoutlet = this.$route.params.idoutlet;
    this.get();
    this.getkota();
    // this.GetNamaDuplikat();
    this.getComponentOutlet();

    this.backButtonPressed(this.back)
    this.smartTrackingView("detail_outlet", {"idoutlet": this.idoutlet});

  },
  computed: {
    inventoryKey() {
      return betaKeys.inventory
    }
  },
  methods: {
    onSelect({name, iso2, dialCode}) {
      this.telpCode = dialCode
    },
    routeToSubmodule() {
      if (this.$route.params.submodule === undefined) {
        return
      }
      if (this.$route.params.submodule !== "") {
        setTimeout(() => {
          $('#detailoutlet').hide();

          switch (this.$route.params.submodule) {
            case "emoney":
              this.gopayment(this.$route.params.idoutlet)
              break
            case "layanan":
              this.golayanan(this.$route.params.idoutlet)
              break
          }
        }, 100)
      }
    },

    cekOnboardingLayanan() {
      if (localStorage.getItem("step_walkthrough") != undefined && localStorage.getItem("step_walkthrough") == '1') {
        var that = this;
        setTimeout(function () {
          that.onboardingDetailOutlet()

        }, 1000)
        window.scrollTo(0, 50)
      }
      if (process.env.NODE_ENV !== "production") {
        this.imgBucketSrc = this.bucketUrl.ages
      } else {
        this.imgBucketSrc = this.bucketUrl.dalbo
      }
    },

    onboardingDetailOutlet() {
      $(".btn-list-services").addClass("animated pulse slow infinite")
      const tour = new Shepherd.Tour({
        defaultStepOptions: {
          scrollTo: {
            behavior: 'smooth',
            block: 'center'
          },
          // beforeShowPromise: function () {
          //     return new Promise(function (resolve) {
          //         setTimeout(function () {
          //             resolve();
          //         }, 700)
          //     });
          // }
        },
        useModalOverlay: true,
      });
      tour.addSteps([
        {
          classes: '',
          title: 'Kelola layanan outlet',
          text: '<p>Masuk ke menu ini untuk <b>menambahkan, mengubah atau menghapus</b> data layanan yang tersedia di outlet ini.</p> <div>klik <b>Daftar Layanan Reguler</b> untuk kelola data layanan</div>',
          attachTo: {
            element: '.btn-list-services',
            on: 'top'
          },
          advanceOn: {
            selector: '.btn-list-services',
            event: 'click'
          },
        }
      ]);
      tour.start()
    },
    setid(idoutlet) {
      this.idoutlet = idoutlet;
      this.get()
    },
    gosetproduksi(idoutlet) {
      this.smartTrackingClick("pengaturan_proses_produksi", {"idoutlet": this.idoutlet});
      this.issetProduksi = true;
      $('#detailoutlet').hide();
      this.$refs.setproduksi.detailoutlet(idoutlet);
      this.backButtonPressed(this.$refs.setproduksi.back)
    },
    gosettax(idoutlet) {
      this.smartTrackingClick("pengaturan_transaksi", {"idoutlet": this.idoutlet});
      this.istaxsetting = true;
      $('#detailoutlet').hide();
      this.$refs.settax.getpajak(idoutlet);
      this.$refs.settax.setPaketExpress(this.outlet.enable_express)
      this.backButtonPressed(this.$refs.settax.back)
    },
    gosetnota(idoutlet) {
      this.smartTrackingClick("pengaturan_nota", {"idoutlet": this.idoutlet});
      this.issetnota = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.$refs.setnota.getnota(idoutlet);
    },
    gosetlokasioutlet(idoutlet) {
      this.smartTrackingClick("pengaturan_absensi", {"idoutlet": this.idoutlet});
      this.$refs.radiusoutletref.getOutletLocation()
      this.isdatalokasioutlet = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.backButtonPressed(this.$refs.radiusoutletref.back)
    },
    golayanan(idoutlet) {
      this.smartTrackingClick("list_layanan_reguler", {"idoutlet": this.idoutlet});
      this.issetservice = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.$refs.setservice.getlistlayanan(idoutlet);

    },
    goperfume(idoutlet) {
      this.smartTrackingClick("list_parfum", {"idoutlet": this.idoutlet});
      this.isdataperfume = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.$refs.dataperfume.getparfum(idoutlet);
      this.backButtonPressed(this.$refs.dataperfume.back)
    },
    golayanansnap(idoutlet) {
      this.smartTrackingClick("list_layanan_selfservice", {"idoutlet": this.idoutlet});
      if (!this.validateAccess('selfServices.read')) return
      this.issetsnapservice = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.$refs.setservicesnap.getlistlayanansnap(idoutlet);

    },
    golistconsole(idoutlet) {
      this.$router.push({
        name: "SnapConsole",
        params: {idoutlet: idoutlet}
      });
    },
    goitemdetails(idoutlet) {
      this.smartTrackingClick("list_item", {"idoutlet": this.idoutlet});
      this.$router.push({
        name: "DaftarItem",
        params: {idoutlet: idoutlet}
      });
    },

    golistmesin(idoutlet) {
      this.smartTrackingClick("list_mesin", {"idoutlet": this.idoutlet});
      this.$router.push({
        name: "ListSnapMesin",
        query: {idoutlet: idoutlet}
        // name: "ibos",
        // query: {part: 'outlet/snap-mesin-v2/' + idoutlet, label: 'Daftar Mesin Snapbridge'}
      });

    },
    golistkategoriMesin(idoutlet) {
      this.smartTrackingClick("list_kategori", {"idoutlet": this.idoutlet});
      this.$router.push({
        name: "ibos",
        query: {part: 'outlet/snap-tag/' + idoutlet, label: 'Kategori Mesin Snapbridge'}
      });
    },

    godeposit(idoutlet) {
      this.smartTrackingClick("list_deposit", {"idoutlet": this.idoutlet});
      this.isdatadeposit = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      $("#listdeposit").show();
      this.$refs.datadeposit.getlistdeposit();
    },

    gopayment(idoutlet) {
      this.smartTrackingClick("list_epayment", {"idoutlet": this.idoutlet});
      this.isdataepayment = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.$refs.dataepayment.getlistepayment(idoutlet);
    },

    gorak(idoutlet) {
      this.smartTrackingClick("list_rak", {"idoutlet": this.idoutlet});
      this.isdatarak = true;
      $('#detailoutlet').hide();
      document.documentElement.scrollTop = 0;
      this.$refs.datarak.getlistrak(idoutlet);
    },

    goProductSale() {
      this.smartTrackingClick("list_product", {"idoutlet": this.idoutlet});
      this.flutterNavigate('inventory/product/list?id_outlet=' + this.datalistoutlet.idoutlet)
    },

    isdetail() {
      $('#detailoutlet').show();
      this.issetProduksi = false;
      this.istaxsetting = false;
      this.issetnota = false;
      this.issetservice = false;
      this.issetsnapservice = false;
      this.isdataperfume = false;
      this.isdataitem = false;
      this.isdatadeposit = false;
      this.isdataepayment = false;
      this.isdatarak = false;
      this.isdatamesinibos = false;
      this.isdatalokasioutlet = false;
      this.get();
      // this.GetNamaDuplikat();
      this.getComponentOutlet()

      this.backButtonPressed(this.back)
    },

    inputnama(event) {
      var nums = event.target.value;
      var number = nums.replace(/[^0-9A-Za-z_.,() -]+/, '');
      this.duplikat_nama = number
      this.checkvalidasi()
    },

    inputnamaoutlet(event) {
      var nums = event.target.value;
      var number = nums.replace(/[^0-9A-Za-z_.,'()& -]+/, '');
      this.editnama = number
      this.checkvalidasinama()
    },

    inputalamat(event) {
      var nums = event.target.value;
      var number = nums.replace(/[^0-9A-Za-z_.,()/' -]+/, '');
      this.editalamat = number
      this.checkvalidasialamat()
    },

    checkvalidasinama() {
      return
      var inputduplikat = this.editnama;
      var lenPass = inputduplikat.length;
      if (lenPass >= 2) {
        $('#Btneditname').prop('disabled', false);
      } else {
        $('#Btneditname').prop('disabled', true);
      }
    },

    checkvalidasialamat() {
      return
      var inputduplikat = this.editalamat;
      var lenPass = inputduplikat.length;
      if (lenPass >= 2) {
        $('#Btneditname').prop('disabled', false);
      } else {
        $('#Btneditname').prop('disabled', true);
      }
    },


    cekALlList(event) {
      if (event.target.checked == true) {
        $("#textCheckAll").text("Batalkan Semua");
        $(".classCekAll").prop("checked", true);
        this.ceklistproses = ['layanan', 'paket_deposit', 'jenis_parfum', 'pengaturan_rak', 'pengaturan_pajak_promo', 'pengaturan_nota', 'data_workshop', 'paket_epayment']
      } else if (event.target.checked == false) {
        $(".classCekAll").click()
        $("#textCheckAll").text("Pilih Semua");
        $(".classCekAll").prop("checked", false);
        this.ceklistproses = []
      }
    },
    cekItemList(event) {
      if (event.target.checked == false) {
        $("#textCheckAll").text("Pilih Semua");
        $("#customCheck1").prop("checked", false);
        if (event.target.id === "layanan") {
          $("#paket_deposit").prop("checked", false);
        }
      } else {
        if (event.target.id === "paket_deposit") {
          $("#layanan").prop("checked", true);
        }
      }
    },
    async getComponentOutlet() {
      try {
        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_count_component_outlet?idoutlet=' + this.datalistoutlet.idoutlet, this.requestHeaders);
        this.countComponentOutlet = response.data.data
      } catch (e) {

      }
    },
    async get() {
      if (!this.idoutlet) {
        this.idoutlet = this.parentidoutlet
      }
      $('#loadingPage').show();
      $('#loadingPage').addClass('overlayLoading');
      try {
        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + this.datalistoutlet.idoutlet, this.requestHeaders);
        if (response.status === 200) {
          if (response.data.status === true) {
            $('#loadingPage').removeClass('overlayLoading');
            $('#loadingPage').hide()
            this.outlet = response.data.data[0]
            this.outlet.additionalInfo = response.data.aditional_information
            var res = this.outlet
            this.editnama = res.nama;
            //this.edittelp = res.telp;
            this.editalamat = res.alamat;
            this.editkota = res.kota_id;
            this.idoutlet = res.idoutlet;
            this.cekOnboardingLayanan()
            this.nomorWaOnkeyup()
            this.routeToSubmodule()

          }
        }

      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingPage').removeClass('overlayLoading');
        $('#loadingPage').hide()
      }
    },

    myChangeEvent(val) {
      this.myValue = val;
    },
    mySelectEvent(e) {
      this.outlet.kota = e.text;
      this.outlet.kota_id = e.id;
    },
    async getkota() {
      this.optionskota = [];
      try {
        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta', this.requestHeaders)
        if (response.status === 200) {
          var rawkota = response.data.data;
          this.optionskota.push({id: "", text: "Pilih Kota"})
          for (var i = 0; i < rawkota.length; i++) {
            this.optionskota.push({id: rawkota[i].id, text: rawkota[i].nama})
          }
        }
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingPage').removeClass('overlayLoading');
        $('#loadingPage').hide()
      }
    },

    checkvalidasi() {
      var inputduplikat = this.duplikat_nama;
      var lenPass = inputduplikat.length;
      if (lenPass >= 2) {
        $('#buttonduplikat').prop('disabled', false);
      } else {
        $('#buttonduplikat').prop('disabled', true);
      }
    },

    nomorWaOnkeyup() {
      setTimeout(() => {
        this.edittelp = this.edittelp.replace("-", "")
        var phoneField = this.edittelp;
        var frstCar = phoneField.substring(0, 1);
        var firstTel = phoneField.substring(1, 14);
        var secCar = phoneField.substring(0, 2);
        var secTel = phoneField.substring(2, 14);
        var thrdcar = phoneField.substring(0, 14);
        var output


        if (frstCar == 0) {
          output = firstTel
        } else if (secCar == this.telpCode) {
          output = secTel
        } else {
          output = thrdcar
        }
        var number = output.replace(/[^0-9]+/, '');

        var charLenght = number.length;
        if (charLenght >= 8 && charLenght <= 12) {
          // $('#buttontelp').prop('disabled', false);
        } else {
          // $('#buttontelp').prop('disabled', true);
        }
        this.edittelp = number;
      }, 100)
    },

    handleFileUpload() {
      this.logourloutlet = this.$refs.file.files[0];
      var FileSize = this.$refs.file.files[0].size / 1024 / 1024;
      var validphoto = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
      if (FileSize > 2) {
        this.$toast.error('File Gambar tidak boleh lebih dari 2 MB, file anda ' + FileSize.toFixed(2) + ' MB')
        $('#file').val("");
        if (this.logourloutlet == "") {
          $('.logo').attr('src', '/img/Rectangle43.b88d5998.svg');
        } else {
          $('.logo').attr('src', this.logourloutlet);
        }
      } else {
        var blnValid = false;
        for (var j = 0; j < validphoto.length; j++) {
          var sCurExtension = validphoto[j];
          if (this.logourloutlet.name.substr(this.logourloutlet.name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
            blnValid = true;
          }
        }
        if (!blnValid) {
          this.$toast.error('File photo harus menggunakan format jpg, jpeg, dan png')
        } else {
          $('#logo').attr('src', URL.createObjectURL(this.$refs.file.files[0]));
          this.updatepicture()
        }
      }
    },

    async updateAddress() {
      if (this.$v.editalamat.$invalid) {
        this.$v.editalamat.$touch()
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
        return
      }
      try {
        var idowner = localStorage.getItem('idowner')
        const updatedata = new FormData()
        updatedata.append('fieldValue', this.editalamat)
        updatedata.append('fieldName', 'alamat')
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_outlet?idowner=' + idowner + "&idoutlet=" + this.datalistoutlet.idoutlet, updatedata, this.requestHeaders)
        if (response.data.status === true) {
          this.get();
          this.$toast.success(response.data.msg)
          $("#modalEaddress").modal("hide")
        } else {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide()
          this.$toast.error(response.data.msg)
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    async updateName() {
      if (this.$v.editnama.$invalid) {
        this.$v.editnama.$touch()
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
        return
      }
      try {
        var idowner = localStorage.getItem('idowner')
        const updatedata = new FormData()
        updatedata.append('fieldValue', this.editnama)
        updatedata.append('fieldName', 'nama')
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_outlet?idowner=' + idowner + "&idoutlet=" + this.outlet.idoutlet, updatedata, this.requestHeaders)
        if (response.data.status === true) {
          this.get();
          this.$toast.success(response.data.msg)
          $("#modalEname").modal("hide")
        } else {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide()
          this.$toast.error(response.data.msg)
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    async updateTelp() {
      if (this.$v.edittelp.$invalid) {
        this.$v.edittelp.$touch()
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
        return
      }
      try {
        var idowner = localStorage.getItem('idowner')
        const updatedata = new FormData()
        updatedata.append('fieldValue', this.telpCode + this.edittelp)
        updatedata.append('fieldName', 'telp')
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_outlet?idowner=' + idowner + "&idoutlet=" + this.outlet.idoutlet, updatedata, this.requestHeaders);
        if (response.data.status === true) {
          this.get();
          this.$toast.success(response.data.msg)
          $("#modalEtelp").modal("hide")
        } else {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide()
          this.$toast.error(response.data.msg)
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    async updateKota() {
      if (this.$v.editkota.$invalid) {
        this.$v.editkota.$touch()
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
        return
      }
      try {
        var idowner = localStorage.getItem('idowner')
        const updatedata = new FormData()
        updatedata.append('fieldValue', this.editkota)
        updatedata.append('fieldName', 'kota_id')
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_outlet?idowner=' + idowner + "&idoutlet=" + this.outlet.idoutlet, updatedata, this.requestHeaders)
        if (response.data.status === true) {
          this.get();
          this.$toast.success(response.data.msg)
          $("#modalEkota").modal("hide")
        } else {
          this.$toast.error(response.data.msg)
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    async updatepicture() {
      $('#loadingPage').addClass('overlayLoading');
      $('#loadingPage').show();
      try {
        const updatedata = new FormData()
        updatedata.append('logo_url', this.logourloutlet)
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_logo?idoutlet=' + this.datalistoutlet.idoutlet, updatedata, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        })
        if (response.data.status === true) {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide();
          this.get();
          this.$toast.success(response.data.msg)
        } else {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide()
          this.$toast.error(response.data.msg)
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    async deloutlet() {
      this.isClicked = true;
      $('#loadingPage').addClass('overlayLoading');
      try {
        var idowner = localStorage.getItem('idowner')
        const deleteoutlet = new FormData()
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/hide_outlet?idowner=' + idowner + "&idoutlet=" + this.outlet.idoutlet, deleteoutlet, this.requestHeaders)
        if (response.data.status === true) {
          this.back()

          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide();
          this.$toast.success(response.data.data + " berhasil disembunyikan")
        } else {
          $('#loadingPage').removeClass('overlayLoading');
          $('#loadingPage').hide()
          this.$toast.error(response.data.data + " gagal di-nonaktifkan")
        }
      } catch (e) {
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
        this.$catch_error_response(e)
      }
    },

    async GetNamaDuplikat() {
      try {
        const response = await this.$axios.get(this.$baseurl + '/masterData/outlet/cek_nama_outlet_ready?idoutlet=' + this.datalistoutlet.idoutlet, this.requestHeaders)
        if (response.data.status === true) {
          this.duplikat_nama = response.data.data
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
      this.checkvalidasi()
    },

    async DuplikatOutlet() {
      $('#loadingPageImport').addClass('overlayLoading');
      $('#loadingPageImport').addClass('showimportduplicate');
      try {
        const dataForm = new FormData()
        dataForm.append('nama_outlet', this.duplikat_nama)
        var lenghtCheckList = this.ceklistproses.length
        for (var i = 0; i < lenghtCheckList; i++) {
          dataForm.append('opsi_pengaturan[]', this.ceklistproses[i])
        }
        const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/duplicate_data_outlet?idoutlet=' + this.datalistoutlet.idoutlet, dataForm, this.requestHeaders)
        if (response.status === 200) {
          if (response.data.status === true) {
            this.trackDuplicatedata()
            this.myVarLoopingFunc = setInterval(() => {
              this.trackDuplicatedata()
            }, 8000);
          } else {
            $('#loadingPageImport').removeClass('overlayLoading');
            $('#loadingPageImport').removeClass('showimportduplicate');
            this.$toast.error(response.data.msg)
          }
        }
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingPageImport').removeClass('overlayLoading');
        $('#loadingPageImport').removeClass('showimportduplicate');
      }
    },

    async trackDuplicatedata() {
      try {
        const response = await this.$axios.get(this.$baseurl + '/masterData/outlet/track_progress_duplicate_outlet?idoutlet=' + this.datalistoutlet.idoutlet, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        })
        if (response.status === 200) {
          if (response.data.status === true) {
            if (response.data.data.status_progress === '0') {
              var length = response.data.data.lenght_data
              var progress = response.data.data.progress_looping
              var getPercen = (progress / length) * 100;
              var oldData = $("#dataCOunter").text()
              $("#dataCOunter").text(getPercen.toFixed(1))
              this.counter(oldData)
              $("#dataCOunter").text(oldData)
            } else if (response.data.data.status_progress === '1') {
              $('#loadingPageImport').removeClass('overlayLoading');
              $('#loadingPageImport').removeClass('showimportduplicate');
              $("#loadingPageImport").hide()
              clearInterval(this.myVarLoopingFunc);
              var length = response.data.data.lenght_data
              var progress = response.data.data.progress_looping
              var getPercen = 100;
              var oldData = $("#dataCOunter").text()
              $("#dataCOunter").text(getPercen.toFixed(1))
              this.counter(oldData)
              $("#dataCOunter").text(oldData)
              this.ceklistproses = []
              this.GetNamaDuplikat()
              this.$router.push({name: 'detailoutlet', params: {idoutlet: response.data.data.new_idoutlet}})
              this.datalistoutlet.idoutlet = response.data.data.new_idoutlet
              this.get()
              this.$toast.success(response.data.data.msg_progress)
              window.scrollTo(0, 0);
              $("#dataCOunter").text(0)
            } else if (response.data.data.status_progress === '2') {
              $('#loadingPageImport').removeClass('overlayLoading');
              $('#loadingPageImport').removeClass('showimportduplicate');
              clearInterval(this.myVarLoopingFunc);
              $("#dataCOunter").text(0)
              this.$toast.error(response.data.data.msg_progress)
            }
          } else {
            $("#dataCOunter").text(0)
            if (response.data.data.status_progress === '3') {
              $('#loadingPageImport').removeClass('overlayLoading');
              $('#loadingPageImport').removeClass('showimportduplicate');
              clearInterval(this.myVarLoopingFunc);
              this.$toast.error(response.data.data.msg_progress)
            }
          }
        }
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingPageImport').removeClass('overlayLoading');
        $('#loadingPageImport').removeClass('showimportduplicate');
      }
    },

    counter(args) {
      $(".count").prop('Counter', 0).animate({
        Counter: $(".count").text()
      }, {
        duration: 5000,
        easing: 'swing',
        step: function (now) {
          var data = Math.ceil(now)
          if (now >= args) {
            $(".count").text(data);
          }
          if (data == 100) {
            $('#loadingPageImport').removeClass('overlayLoading');
            $('#loadingPageImport').removeClass('showimportduplicate');
          }
        }
      });
    },
    aktivasiOutlet() {
      this.$router.push({name: "ibos", query: {part: 'outlet/outlet/inactive', label: "Aktivasi Outlet"}});
      this.smartTrackingClick("aktivasi_outlet", {"idoutlet": this.idoutlet});
    },

    back() {
      this.$emit('gotolist')
    },
  },
  data() {
    return {
      issetProduksi: false,
      istaxsetting: false,
      issetnota: false,
      issetservice: false,
      issetsnapservice: false,
      isdataperfume: false,
      isdataitem: false,
      isdatadeposit: false,
      isdataepayment: false,
      isdatarak: false,
      isdatamesinibos: false,
      isdatalokasioutlet: false,
      idoutlet: this.datalistoutlet,
      outlet: {},
      logourloutlet: '',
      selectedkota: '1',
      optionskota: [],
      isClicked: true,
      rak: [],
      editnama: '',
      telpCode: '',
      edittelp: '',
      editalamat: '',
      editkota: '',
      ceklistproses: [],
      duplikat_nama: '',
      countComponentOutlet: {},
      requestHeaders: {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        }
      },
      bucketUrl: {
        dalbo: 'https://storage.googleapis.com/ember-e-dalbo/',
        ages: 'https://storage.googleapis.com/',
      },
      imgBucketSrc: "",
    }

  },
}
</script>

<style scoped>
.showimportduplicate {
  display: block !important;
}

#loadingPageImport {
  display: none;
}

.upload-file {
  border-bottom: 1px solid #EDEDED;
}

.upload-file-wrapper {
  width: 100px;
  height: 100px;
  margin: 20px auto;
  border: 1px solid rgba(0, 0, 0, 0.15);
  position: relative;
}

.text-detailO {
  border-bottom: 1px solid #EDEDED;
  padding: 12px 20px;

}

.pointer-upload {
  display: flex;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background: #206CFF;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  animation: pulse 2s infinite;
  align-content: center;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* bottom: 70px; */
  right: -15px;
  bottom: -15px;
}

.color-80808 {
  color: #808080;
}

.pembatas-new {
  display: block;
  width: 100%;
  height: 8px;
  background: #F2F5F7;
  margin-top: 0px;
}

.input-upload {
  display: none;
}

.box {
  width: 95.53px;
  height: 95.53px;
}

.imgFit {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
  margin-top: 2px;
}

.nomore {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text-desc {
  line-height: 140%;
  letter-spacing: -0.02em;
  color: #333333;
}

#modalDuplikat.modal-dialog {
  transform: translate(0, 100px) !important;
}

.line-height-18 {
  line-height: 18px;
}

.letter-space-002 {
  letter-spacing: -0.02em;
}

</style>
